<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-sm-12">
          <div class="row mb-2">
            <div class="col-auto my-auto">
              <p v-if="activeServiceType == 'Gas'" class="d-inline font-weight-bold">MPRN:</p>
              <p
                v-else-if="activeServiceType == 'Electricity'"
                class="d-inline font-weight-bold"
              >MPAN:</p>
              <p class="d-inline font-weight-bold ml-1">{{activeService.ServiceIdentifier}}</p>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-12 col-lg-6">
              <div class="row">
                <div class="col-md-4">
                  <p class="font-weight-bold">Effective From:</p>
                </div>
                <div class="col-md-8">
                  <p>{{activeTenancy.EffectiveFrom | moment('Do MMMM YYYY')}}</p>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="row">
                <div class="col-md-4">
                  <p class="font-weight-bold">Effective To:</p>
                </div>
                <div class="col-md-8">
                  <p
                    v-if="activeTenancy.hasOwnProperty('EffectiveTo')"
                  >{{activeTenancy.EffectiveTo | moment('Do MMMM YYYY')}}</p>
                  <p v-else>Present</p>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-6">
              <div class="row">
                <div class="col-md-4">
                  <p class="font-weight-bold">Site:</p>
                </div>
                <div class="col-md-8 pt-4">
                  <p
                    class="mt--20"
                    v-for="(line, index) in activeService.Site.Address.AddressLines"
                    :key="index"
                  >{{line}}</p>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div v-if="activeSection != 'CommercialConfig'">
            <div class="row mb-2">
              <div class="col-10 my-auto">
                <p class="font-weight-bold">Commercial Configurations</p>
              </div>
              <div class="col-2 d-inline my-auto">
                <img
                  v-if="!disableEdit"
                  @click="$bvModal.show('addCommercialConfig')"
                  src="@/assets/img/add_icon_hcg.png"
                  class="d-inline-block pointer float-right"
                  alt="Add Icon"
                />
              </div>
            </div>
            <!-- Gas table -->
            <div class="row" v-if="activeServiceType === 'Gas'">
              <div class="col-sm-12">
                <div class="bg-secondaryL p-2 W-100">
                  <div class="table-responsive-lg">
                    <b-table
                      id="ThisIdOverwritesTheRandomlyGeneratedOneSoThatSnapshotTestsDoNotFailEveryTime_4"
                      responsive
                      striped
                      fixed
                      :items="orderByEffectiveFrom(activeService.GasDetails.CommercialConfigurations)"
                      :fields="commercialConfigFields"
                      hover
                      @row-clicked="selectCommercialConfig"
                    >
                      <template
                        slot="EffectiveFrom"
                        slot-scope="data"
                      >{{data.item.EffectiveFrom | moment('Do MMMM YYYY')}}</template>

                      <template slot="EffectiveTo" slot-scope="data">
                        <div
                          v-if="data.item.EffectiveTo"
                        >{{data.item.EffectiveTo | moment('Do MMMM YYYY')}}</div>
                        <div v-else>Present</div>
                      </template>

                      <template slot="CommercialPercentage" slot-scope="data">
                        <div v-if="data.item.CommercialPercentage == 100">Commercial</div>
                        <div v-if="data.item.CommercialPercentage == 0">Domestic</div>
                        <div
                          v-if="data.item.CommercialPercentage > 0 && data.item.CommercialPercentage < 100"
                        >Mixed</div>
                      </template>

                      <template slot="BillingAq" slot-scope="data">
                        <div v-if="data.item.BillingAq">{{data.item.BillingAq}} kwh</div>
                      </template>
                      <template slot="Actions" slot-scope="row">
                        <div class="d-flex w-100 justify-content-center align-self-center">
                          <i
                            v-if="!disableEdit && currentConfig(row) && activeService.GasDetails.CommercialConfigurations.length > 1"
                            class="float-right pointer fas fa-trash mt-2 mx-2"
                            @mouseover="isSelectable=false"
                            @mouseleave="isSelectable=true"
                            @click="toggleDeleteConfirmation(row)"
                          ></i>
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
            </div>
            <!-- Elec table -->
            <div class="row" v-if="activeServiceType === 'Electricity'">
              <div class="col-sm-12">
                <div class="bg-secondaryL p-2 W-100">
                  <div class="table-responsive-lg">
                    <div class="col-sm-12">
                      <div class="bg-secondaryL p-2 W-100">
                        <b-table
                          id="ThisIdOverwritesTheRandomlyGeneratedOneSoThatSnapshotTestsDoNotFailEveryTime_5"
                          responsive
                          striped
                          hover
                          fixed
                          :items="orderByEffectiveFrom(activeService.ElectricityDetails.CommercialConfigurations)"
                          :fields="commercialConfigFieldsElec"
                          @row-clicked="selectCommercialConfig"
                        >
                          <template
                            slot="EffectiveFrom"
                            slot-scope="data"
                          >{{data.item.EffectiveFrom | moment('Do MMMM YYYY')}}</template>

                          <template slot="EffectiveTo" slot-scope="data">
                            <div
                              v-if="data.item.EffectiveTo"
                            >{{data.item.EffectiveTo | moment('Do MMMM YYYY')}}</div>
                            <div v-else>Present</div>
                          </template>

                          <template slot="CommercialPercentage" slot-scope="data">
                            <div v-if="data.item.CommercialPercentage == 100">Commercial</div>
                            <div v-if="data.item.CommercialPercentage == 0">Domestic</div>
                            <div
                              v-if="data.item.CommercialPercentage > 0 && data.item.CommercialPercentage < 100"
                            >Mixed</div>
                          </template>
                          <template slot="Eac" slot-scope="data">
                            <div>{{data.item.MeterPointBillingEac}}</div>
                          </template>
                          <template slot="Actions" slot-scope="row">
                            <div class="d-flex w-100 justify-content-center align-self-center">
                              <i
                                v-if="!disableEdit && currentConfig(row) && activeService.ElectricityDetails.CommercialConfigurations.length > 1"
                                class="float-right pointer fas fa-trash mt-2 mx-2"
                                @mouseover="isSelectable=false"
                                @mouseleave="isSelectable=true"
                                @click="toggleDeleteConfirmation(row)"
                              ></i>
                            </div>
                          </template>
                        </b-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <CommercialConfig v-else-if="activeSection==='CommercialConfig'" />
        </div>
      </div>
    </div>
    <!-- Modals -->
    <b-modal id="deleteConfig">
      <template slot="modal-header" slot-scope="{ close }">
        <div class="container-fluid">
          <div class="row">
            <div class="col-9 my-auto">
              <h5 class="modal-title">Delete Commercial Configuration</h5>
            </div>
            <div class="col-3 my-auto">
              <div>
                <div>
                  <span>
                    <a class="close">
                      <i
                        class="far fa-times-circle fa-2x"
                        @click="close()"
                        id="closeDeleteConfigConfirmation"
                        aria-label="Close"
                      ></i>
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="default">
        <p class="my-4 text-center">Are you sure you want to delete this commercial configuration?</p>
      </template>
      <template slot="modal-footer" slot-scope="{ close }">
        <button
          type="submit"
          class="btn btn-hc float-right"
          @click="deleteCommercialConfig"
          :disabled="submitStatusConfig == 'PENDING'"
        >Yes</button>
        <button
          type="submit"
          class="btn btn-hc float-right"
          @click="close()"
          :disabled="submitStatusConfig == 'PENDING'"
        >No</button>
      </template>
    </b-modal>
    <add-commercial-config
      v-if="activeSection === 'GasService' || activeSection === 'ElectricityService'"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import { _ } from 'underscore';
import CommercialConfig from './CommercialConfiguration.vue';
import AddCommercialConfig from '../modals/AddCommercialConfig';

// Mixins
import snotifyHttpError from '@/mixins/snotifyHttpResponses';
import contractsMixin from '@/mixins/contracts/contracts';

export default {
  mixins: [snotifyHttpError, contractsMixin],
  components: {
    CommercialConfig,
    AddCommercialConfig,
  },
  data() {
    return {
      isSelectable: true,
      submitStatusService: null,
      submitStatusConfig: null,
      editConfig: null,
      commercialConfigFieldsElec: {
        EffectiveFrom: {
          label: 'Effective From',
          class: 'text-left',
          sortable: true,
        },
        EffectiveTo: {
          label: 'Effective To',
          class: 'text-left',
          sortable: true,
        },
        CommercialPercentage: {
          label: 'Usage',
          class: 'text-left',
        },
        Eac: {
          label: 'Meter Point EAC',
          class: 'text-left',
          sortable: true,
        },
        Actions: {
          label: '',
          class: 'short-field',
        },
      },
      commercialConfigFields: {
        EffectiveFrom: {
          label: 'Effective From',
          class: 'text-left',
          sortable: true,
        },
        EffectiveTo: {
          label: 'Effective To',
          class: 'text-left',
          sortable: true,
        },
        CommercialPercentage: {
          label: 'Usage',
          class: 'text-left',
        },
        BillingAq: {
          label: 'Billing AQ',
          class: 'text-left',
          sortable: true,
        },
        Actions: {
          label: '',
          class: 'short-field',
        },
      },
    };
  },
  computed: {
    eacTotal() {
      if (this.activeServiceType === 'Gas') return null;
      let eacTotal = 0;
      this.activeService.ElectricityDetails.CommercialConfigurations.forEach(
        (config) => {
          eacTotal += config.MeterPointBillingEac;
        }
      );
      return eacTotal;
    },
    disableEdit() {
      return this.activeContract.ContractStatus == 'NotChargeable';
    },
  },
  methods: {
    selectCommercialConfig(commercialConfig) {
      if (this.isSelectable) {
        this.$store.commit('updateActiveCommercialConfig', commercialConfig);
        this.navigateTo('CommercialConfig');
      }
    },
    orderByEffectiveFrom(collection) {
      return this.$_.sortBy(collection, function(item) {
        return item.EffectiveFrom;
      }).reverse();
    },
    currentConfig(row) {
      if (this.activeServiceType === 'Gas') {
        return (
          _.sortBy(
            this.activeService.GasDetails.CommercialConfigurations,
            'EffectiveFrom'
          ).reverse()[0].EffectiveFrom == row.item.EffectiveFrom
        );
      } else if (this.activeServiceType === 'Electricity') {
        return (
          _.sortBy(
            this.activeService.ElectricityDetails.CommercialConfigurations,
            'EffectiveFrom'
          ).reverse()[0].EffectiveFrom == row.item.EffectiveFrom
        );
      }
    },
    toggleDeleteConfirmation(row) {
      this.$bvModal.show('deleteConfig');
      this.editConfig = row.item;
    },
    deleteCommercialConfig() {
      this.submitStatusConfig = 'PENDING';
      let commercialConfigType =
        this.activeServiceType == 'Gas'
          ? '/gas-commercials/'
          : '/elec-commercials/';
      this.$http
        .delete(
          'https://' +
            Vue.config.honeycomb.queenbee.domain +
            '/api/v1/contracts/' +
            this.activeContract.Id +
            '/services/' +
            this.activeService.ServiceIdentifier +
            commercialConfigType +
            this.editConfig.Id,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.submitStatusConfig = 'OK';
          this.$snotify.success(`Success! Configuration deleted.`);
          this.$store.dispatch('getContracts');
          this.activeContract = response.data;
          this.activeService = response.data.Services.filter(
            (service) =>
              service.ServiceIdentifier == this.activeService.ServiceIdentifier
          )[0];
          document.getElementById('closeDeleteConfigConfirmation').click();
        })
        .catch((error) => {
          this.submitStatusConfig = 'ERROR';
          if (error.response) {
            if (error.response.data.MoreInformation.length > 0) {
              error.response.data.MoreInformation.forEach((e) => {
                this.$snotify.error(`${e.Error}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              });
            } else {
              this.$snotify.error(`${error.response.data.UserDescription}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          } else if (error.request) {
            this.$snotify.error(`No response recieved.`, {
              timeout: 0,
              closeOnClick: true,
            });
          } else {
            this.$snotify.error(`${error.message}`, {
              timeout: 0,
              closeOnClick: true,
            });
          }
        });
    },
    saveServiceChanges() {
      this.submitStatusService = 'PENDING';
      this.activeService.DoNotBill = !this.activeService.DoNotBill;

      this.$snotify.async(
        'Saving Changes',
        () =>
          new Promise((resolve, reject) => {
            this.$http
              .put(
                'https://' +
                  Vue.config.honeycomb.queenbee.domain +
                  '/api/v1/contracts/' +
                  this.activeContract.Id +
                  '/services/' +
                  this.activeService.ServiceIdentifier,
                {
                  ServiceIdentifier: this.activeService.ServiceIdentifier,
                  DoNotBill: this.activeService.DoNotBill,
                },
                {
                  withCredentials: true,
                }
              )
              .then((response) => {
                this.submitStatusService = 'OK';
                this.$store.dispatch('getContracts');
                this.activeService = _.find(
                  response.data.Services,
                  (service) =>
                    service.ServiceIdentifier ==
                    this.activeService.ServiceIdentifier
                );
                this.activeContract = response.data;

                resolve({
                  title: 'Success!',
                  body: 'Changes saved!',
                  config: {
                    closeOnClick: true,
                    timeout: 2000,
                  },
                });
              })
              .catch((error) => {
                this.submitStatusService = 'ERROR';
                Object.assign(this.activeService, this.beforeEditingService);
                reject(this.snotifyHttpError(error));
              });
          })
      );
    },
  },
};
</script>
